import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  DialogActions,
  Button,
} from "@mui/material";

export default function ChooseSignerModal({
  handleConfirmation,
  signer,
  setSigner,
  open,
  setOpen,
}) {
  const [signers, setSigners] = useState(null);

  const getSigners = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/getSigners`,
      { withCredentials: true },
    );

    return response.data;
  };

  useEffect(() => {
    if (open) {
      getSigners()
        .then((signers) => {
          setSigners(signers);
        })
        .catch((error) => {
          console.log(error.message);
        });
    }
  }, [open]);

  return (
    <>
      <Dialog
        open={open}
        fullWidth={true}
        sx={{
          height: "100%",
        }}
      >
        <DialogTitle style={{ fontSize: "1.2rem" }}>
          Βεβαίωση Οφειλών
        </DialogTitle>
        <DialogContent>
          <DialogContentText style={{ fontSize: "1rem" }}>
            Για να συνεχίσετε με την βεβαίωση των οφειλών θα πρέπει να επιλέξετε
            υπογράφων που έχει καταχωρηθεί στο σύστημα. Αν ο υπογράφων που
            επιθυμείτε δεν βρίσκετε στην παρακάτω λίστα μεταβείτε στην οθόνη
            δήλωση υπογραφόντων για να τον καταχωρήσετε.
          </DialogContentText>
          <FormControl
            sx={{
              mt: 5,
              mb: 2,
            }}
            required
            fullWidth
          >
            <InputLabel>Υπογράφων</InputLabel>
            <Select value={signer.value} label="Υπογράφων">
              {signers ? (
                signers.map((_signer, index) => (
                  <MenuItem
                    onClick={() => {
                      setSigner({
                        id: _signer.id,
                        value: _signer.value,
                      });
                    }}
                    key={index}
                    value={_signer.value}
                  >
                    {_signer.value}
                  </MenuItem>
                ))
              ) : (
                <MenuItem>Δεν βρέθηκαν ενεργοί υπογράφοντες</MenuItem>
              )}
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions sx={{ p: 3 }}>
          <Button
            color="error"
            onClick={() => {
              setOpen(false);
            }}
          >
            Ακύρωση
          </Button>
          <Button
            color="success"
            variant="contained"
            onClick={() => {
              setOpen(false);
              handleConfirmation();
            }}
            disabled={!signer.id}
          >
            Βεβαίωση
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
